
class Popin {
  constructor() {
    this._init();
    this._initCoachSelect();
  }
  _init() {
    const popinButtons = document.querySelectorAll<HTMLButtonElement>('[data-popin-btn]');
    const popinCloses = document.querySelectorAll<HTMLElement>('[data-popin-close]');
    const body = document.body;

    const disableScroll = () => {
      body.style.overflow = 'hidden';
    };

    const enableScroll = () => {
      body.style.overflow = '';
    };

    // CF7 Envoyé
    document.addEventListener('wpcf7mailsent', (event: any) => {
      const form = event.target as HTMLElement;

      // On cherche la popin parente du formulaire soumis
      const parentPopin = form.closest('[data-popin-id]');

      if (parentPopin instanceof HTMLElement) {
        this.showSuccess(parentPopin);
      }
    }, false);

    const closePopin = (popin: HTMLElement) => {
      popin.classList.remove('active');

      const iframe = popin.querySelector<HTMLIFrameElement>('iframe');
      if (iframe) {
        const currentSrc = iframe.getAttribute('src');
        if (currentSrc) {
          iframe.setAttribute('data-src', currentSrc.replace('&autoplay=1', '').replace('?autoplay=1', ''));
          iframe.setAttribute('src', '');
        }
      }
    };

    // Ouvrir la popin
    popinButtons.forEach(button => {
      button.addEventListener('click', () => {
        const popinId = button.getAttribute('data-popin-btn');
        if (!popinId) return;

        const popin = document.querySelector<HTMLElement>(`[data-popin-id="${popinId}"]`);
        if (popin) {
          if (button.hasAttribute('data-popin-switch')) {
            document.querySelectorAll<HTMLElement>('[data-popin-id].active').forEach(activePopin => {
              if (activePopin !== popin) {
                closePopin(activePopin);
              }
            });
          }

          popin.classList.add('active');
          disableScroll();

          // Redémarrer la vidéo (YouTube) si présente
          const iframe = popin.querySelector<HTMLIFrameElement>('iframe');
          if (iframe) {
            const baseSrc = iframe.getAttribute('data-src') || iframe.getAttribute('src');
            if (baseSrc) {
              const newSrc = baseSrc.includes('?') ? `${baseSrc}&autoplay=1` : `${baseSrc}?autoplay=1`;
              iframe.setAttribute('src', newSrc);
            }
          }

          // Vérifie si le bouton est de type document
          if (popinId.startsWith('document-')) {
            const postId = popinId.replace('document-', '');
            const hiddenInput = popin.querySelector<HTMLInputElement>('input[name="document_id"]');
            if (hiddenInput) hiddenInput.value = postId;
          }
        }
      });
    });

    // Fermer la popin
    popinCloses.forEach(close => {
      close.addEventListener('click', () => {
        const popins = document.querySelectorAll<HTMLElement>('[data-popin-id]');
        popins.forEach(popin => closePopin(popin));

        enableScroll();
      });
    });
  }

  /**
   * Sélection du coach : soumission AJAX + états chargement/erreur/succès
   */
  private _initCoachSelect(): void {
    const popins = document.querySelectorAll<HTMLElement>('.popin--coach-select');

    popins.forEach(popin => {
      const select = popin.querySelector<HTMLSelectElement>('[data-coach-select]');
      const submitBtn = popin.querySelector<HTMLButtonElement>('[data-coach-submit]');
      const errorEl = popin.querySelector<HTMLElement>('[data-coach-error]');

      if (!select || !submitBtn) return;

      select.addEventListener('change', () => {
        submitBtn.disabled = !select.value;
      });

      submitBtn.addEventListener('click', async () => {
        if (!select.value) return;

        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        const formData = new FormData();
        formData.append('action', 'select_coach');
        formData.append('coach_id', select.value);
        formData.append('nonce', (window as any).ajax?.nonce);

        try {
          const response = await fetch((window as any).ajax?.ajax_url, {
            method: 'POST',
            body: formData,
          });
          const result = await response.json();

          if (result.success) {
            window.location.reload();
          } else {
            this._showCoachError(errorEl, result.data);
            submitBtn.disabled = false;
          }
        } catch (error) {
          console.error('Erreur réseau ou serveur :', error);
          this._showCoachError(errorEl, null);
          submitBtn.disabled = false;
        } finally {
          submitBtn.removeAttribute('aria-busy');
        }
      });
    });
  }

  private _showCoachError(errorEl: HTMLElement | null, message?: string | null): void {
    if (!errorEl) return;
    errorEl.textContent = message || 'Une erreur est survenue, veuillez réessayer.';
    errorEl.hidden = false;
  }

  /**
   * Masque le formulaire et affiche le succès pour une popin précise
   */
  private showSuccess(popin: HTMLElement) {
    const intro = popin.querySelector<HTMLElement>('[data-popin-form-intro]');
    const formContainer = popin.querySelector<HTMLElement>('[data-popin-form]');
    const success = popin.querySelector<HTMLElement>('[data-popin-form-success]');

    // On utilise display: none / block pour basculer les vues
    if (intro) intro.style.display = 'none';
    if (formContainer) formContainer.style.display = 'none';

    if (success) {
      success.style.display = 'block';
      popin.scrollTop = 0;
    }
  }
}

export const popin = new Popin();